// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__31UwA","author":"Table_author__1UByV","authorImage":"Table_authorImage__Ioz0Y","unreadRow":"Table_unreadRow__1QlSp"};